export const USER_MODIFY_BEGIN = 'USER_MODIFY_BEGIN';
export const USER_MODIFY_SUCCESS = 'USER_MODIFY_SUCCESS';
export const USER_MODIFY_ERROR = 'USER_MODIFY_ERROR';
export const USER_MODIFY_RESET = 'USER_MODIFY_RESET';
